<div class="toast-overlay" *ngIf="toastMessages$ | async as messages">
	<div
		class="toast-container"
		[@fadeInOutAnimation]
		*ngFor="let toast of messages.toasts"
	>
		<div class="toast-content">
			<img *ngIf="toast.toastType === 'SUCCESS'" src="/assets/icons/check-icon.svg" role="presentation"/>
			<span class="toast-message">{{ toast.message }}</span>
		</div>
	</div>
</div>
